/**
 * Include your custom JavaScript here.
 * (Focal developer documentation: see the theme 'Focal(デフォルト・いじらない)')
 */

/* Aloha運命数診断：運命数11・22・33以外で「MASTER NUMBER」バッジが出てしまう表示を修正（2026-10-24） */
(function () {
  var s = document.createElement('style');
  s.textContent = '.aen-master[hidden]{display:none!important}';
  (document.head || document.documentElement).appendChild(s);
})();

/* Aloha運命数診断：結果の特典欄のサイズ交換を「7日以内」に（返品ポリシーに合わせる・2026-10-24） */
(function () {
  function fix() {
    document.querySelectorAll('.aen-perks li').forEach(function (li) {
      if (li.innerHTML.indexOf('2週間以内') !== -1) li.innerHTML = li.innerHTML.replace('2週間以内', '7日以内');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fix); else fix();
})();
